import React from 'react';
import {connect} from 'react-redux';
import {setSimCardType, setCurrentPopUp, setDeviceSupportsEsim} from '../../TransferOrganizationAccountSlice';
import {simCardType} from '../../Constant/Constant';
import SelectOptionButton from '../../../../Shared/SelectOptionButton/SelectOptionButton';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import {buildUrlAndOpenWindow} from '../../../../../utilities/StringHelpers/StringHelpers';

const SelectSimTypeComponent = (props) => {
  const simTypeOptions = [
    {
      id: '0',
      label: 'SIM רגיל',
      value: simCardType.sim,
      rightContent: getSimPrice(props.data.price.simPrice),
      selected: props.data.simCardType === simCardType.sim ? true : false,
    },
    {
      id: '1',
      label: 'eSIM',
      value: simCardType.eSim,
      rightContent: getSimPrice(props.data.price.esimPrice),
      selected: props.data.simCardType === simCardType.eSim ? true : false,
    },
  ];
  function getSimPrice(price) {
    if (parseInt(price) === 0) {
      return 'ללא עלות';
    } else {
      return `<div><span class='sim-card-price'>₪${price}</span> </br> <span class='sim-card-price-text'>חד פעמי</span></div>`;
    }
  }

  return (
    <div className='transfer-line-sub-step borderline'>
      <SelectOptionButton title={'מה סוג ה-SIM החדש?'} buttonsData={simTypeOptions} onClick={props.setSimCardType} />
      {props.data.simCardType === simCardType.eSim && (
        <>
          <div className='supportsEsim-checkbox'>
            <CheckBox
              id='supportsEsim'
              checked={props.data.deviceSupportsEsim}
              label={'בדקתי והמכשיר תומך ב-eSIM'}
              onChange={() => props.setDeviceSupportsEsim(!props.data.deviceSupportsEsim)}
            />
          </div>

          <a
            className='link'
            onClick={() => {
              buildUrlAndOpenWindow(props.data.epiData?.cellularDevicesSupportedUrl?.value);
            }}>
            האם המכשיר שלי תומך ב-eSIM?
          </a>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.TransferOrganizationAccount,
  };
};

const mapDispatchToProps = {
  setSimCardType,
  setCurrentPopUp,
  setDeviceSupportsEsim,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectSimTypeComponent);
